import { store } from '../../../store';

export const SUPPORT_ACCOUNT_SUFFIX = '@ingame-support.com';

export const isSupportUser = () => {
  return store
    .getState()
    .common.userInfo?.UserID.endsWith(SUPPORT_ACCOUNT_SUFFIX);
};
